module.exports = __webpack_public_path__ + "static/media/icon-success.e24186c6.svg";